/**
 * Turkce katalog — TEK gercek katalog. (en.ts bilincli olarak bos bir taslak.)
 *
 * Anahtar yapisi dovizhub-mobile/src/shared/translation/locales/tr.ts ile AYNI
 * tutulur. Iki istemci ayni sunucuyu konusuyor; ayni kavramin iki farkli anahtar
 * altinda yasamasi, metin degisikliklerinin yalniz birinde uygulanmasina yol acar.
 * Web'e ait olmayan namespace'ler (onboarding, tabs, routes, places, thunkErrors)
 * bilincli olarak tasinmadi; gerektiginde mobil dosyadan AYNI adla alinir.
 *
 * i18next EKSIK ANAHTARDA HATA VERMEZ — anahtarin kendisini basar ("task.tabs.all"
 * ekranda oyle gorunur). Bu yuzden src/i18n/__tests__/keys.test.ts kaynak agacini
 * tarar ve her t('...') / *Key: '...' degerinin burada var oldugunu dogrular.
 */
const tr = {
  // ⚠ KOK SEVIYE — TASIMAYIN. Bu dort anahtar sunucudan gelen countdownStatus
  // degeriyle DOGRUDAN t()'ye giriyor: t(quote.countdownStatus). Bir namespace'e
  // tasinirsa t() anahtarin kendisini ("offer") basar ve teklif kartlari sessizce bozulur.
  offer: 'Teklifler Toplanıyor',
  decide: 'Onay Bekliyor',
  passive: 'İstek Kapandı',
  payment: 'Ödeme Bekliyor',
  // Sunucudan GELMEZ, faz rozeti turetir (2026-09-26, lib/task-phase.ts phaseLabelKey):
  // 'payment' fazi + 'payment_received' durumu. Musteri odemesini yapmis, buronun 15 dakikalik
  // gonderimi suruyor; "Ödeme Bekliyor" yanlis olurdu. Mobil tr.ts ile AYNI kok anahtar.
  payout: 'Gönderim Bekliyor',

  fullName: 'Ad Soyad',
  email: 'Email',

  common: {
    retry: 'Tekrar dene',
    comingSoon: 'Bu bölüm bir sonraki sürümde açılacak.',
    cancel: 'Vazgeç',
    close: 'Kapat',
    ok: 'Tamam',
    success: 'Başarılı',
    loading: 'Yükleniyor…',
  },

  errors: {
    generic: 'Bir sorun oluştu',
    title: 'Hata',
    warning: 'Uyarı',
    noPermission: 'Yetkiniz yok',
    noPermissionDetail:
      'Bu bölüm için yetkiniz bulunmuyor. İşletme yöneticinizden talep edebilirsiniz.',
    notFound: 'Sayfa bulunamadı',
    notFoundDetail: 'Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.',
    backHome: 'Ana sayfaya dön',
    // Pazaryeri sunucu kodlari (2026-09-23 is kurallari). Esleme:
    // src/features/tasks/error-message.ts (TASK_ERROR_MESSAGE_KEYS).
    offerWindowOpen:
      'Teklifler hâlâ toplanıyor. Teklif seçimi, teklif toplama süresi bitince yapılabilir.',
    cancelWindowClosed:
      'Teklif toplama süresi bitti; talep artık iptal edilemez.',
    warningTooEarly:
      'Ödeme süresi henüz dolmadı. Uyarı, ödeme süresi bittikten sonra gönderilebilir.',
    disputeWindowClosed: 'Bu işlem için itiraz süresi doldu; uyarı gönderilemez.',
    taskExpired: 'Talebin süresi doldu; bu işlem artık yapılamaz.',
    taskAlreadyDecided: 'Bu talep için zaten bir teklif onaylandı.',
    taskAlreadyCancelled: 'Bu talep iptal edilmiş.',
    invalidStatusTransition: 'Talebin şu anki durumunda bu işlem yapılamaz. Sayfayı yenileyin.',
    taskStatusRequired: 'İstek eksik gönderildi. Sayfayı yenileyip tekrar deneyin.',
    taskNotFound: 'Talep bulunamadı. Liste güncel olmayabilir; sayfayı yenileyin.',
    taskNotOwned: 'Bu işlemi yalnızca talebi oluşturan kişi yapabilir.',
    taskNotWinner:
      'Bu işlemi yalnızca teklifi kazanan büro (ya da yetkili çalışanları) yapabilir.',
    permissionDenied:
      'Bu işlem için yetkiniz yok. İşletme yöneticinizden talep edebilirsiniz.',
    // Bir buro bir teklif (2026-10-03): is arkadasi teklif vermis, cagiranin `editOffer`'i yok.
    // Piyasa karti / detayindaki not da AYNI metin (dugme yerine).
    organizationOfferExists:
      'Büronuz bu talebe teklif verdi; güncellemek için Teklif güncelleme yetkisi gerekir.',
    taskNotOpenForOffers: 'Bu talep artık teklife açık değil.',
    offerWithdrawNotSupported:
      'Teklif geri çekilemez; teklif toplama süresi içinde yalnızca güncellenebilir.',
    offerPriceMustBePositive: 'Kur sıfırdan büyük olmalı.',
    accountLegMismatch:
      'Seçilen hesap bu işleme uymuyor: talebin bankasında ve doğru para biriminde bir hesap gerekir.',
    accountCounterLegMissing:
      'Seçtiğiniz bankada işlemin karşı para birimi için de bir hesabınız olmalı.',
  },

  filter: {
    title: 'Filtrele',
    apply: 'Uygula',
    clearAll: 'Filtreleri temizle',
    search: 'Ara…',
    currency: 'Para birimi',
    dateRange: 'Tarih aralığı',
    dateFrom: 'Başlangıç',
    dateTo: 'Bitiş',
    amountRange: 'Tutar aralığı',
    amountMin: 'En az',
    amountMax: 'En çok',
    sort: 'Sıralama',
    sortNewest: 'En yeni',
    sortOldest: 'En eski',
    sortAmountDesc: 'Tutar ↓',
    sortAmountAsc: 'Tutar ↑',
    sortPriceAsc: 'En düşük fiyat',
    sortPriceDesc: 'En yüksek fiyat',
    sortOfferNewest: 'En yeni teklif',
    sortCustomerAsc: 'Müşteri (A→Z)',
  },

  list: {
    empty: {
      title: 'Henüz kayıt yok',
    },
    noResults: {
      title: 'Sonuç bulunamadı',
      description: 'Filtreleri değiştirmeyi deneyin.',
      action: 'Filtreleri temizle',
    },
    error: {
      title: 'Yüklenemedi',
      network: 'Bağlantı kurulamadı. İnternetinizi kontrol edin.',
      generic: 'Bir sorun oluştu.',
    },
    endOfList: 'Hepsi bu kadar',
    loadingMore: 'Yükleniyor…',
  },

  // Kabuk gezinmesi. Menu VERIDIR (src/layout/menus.ts) ve yalniz `labelKey`
  // tutar; ceviri render sirasinda yapilir.
  nav: {
    primary: 'Ana gezinme',
    skipToContent: 'İçeriğe geç',
    openMenu: 'Menü',
    zoneCustomer: 'Müşteri',
    zoneExchange: 'Döviz bürosu',
    zoneAdmin: 'Platform yönetimi',
    // Menu grup baslıkları (MenuItem.groupKey). Kısa ve tek kelime tutuluyor:
    // kenar çubuğunda satır kaydırması bir başlığı iki satıra düşürüyor.
    groupOperations: 'İşlemler',
    groupInsights: 'Analiz',
    groupManagement: 'Yönetim',
    groupPlatform: 'Platform',
    rates: 'Kurlar',
    dashboard: 'Özet',
    myRequests: 'Taleplerim',
    incomingOffers: 'Gelen teklifler',
    // Buronun Piyasa ekrani (K1, 2026-10-02). Mobil sekme cubugu ve ekran basligi zaten
    // "Piyasa"ydi; web menusu "Gelen talepler" diyordu, ayni ekranin iki adi vardi.
    quoteRequests: 'Piyasa',
    myOffers: 'Tekliflerim',
    accounts: 'Banka hesapları',
    reports: 'Raporlar',
    organization: 'İşletmem',
    team: 'Ekip ve yetkiler',
    auditLog: 'İşlem geçmişi',
    profile: 'Profil',
    platformUsers: 'Kullanıcılar',
    platformOrganizations: 'İşletmeler',
    platformMetrics: 'Metrikler',
    platformWarnedTasks: 'Uyarılar',
  },

  // Dönem kıyası rozeti (ui/TrendBadge). Metinler yalnız ekran okuyucuya gider;
  // görsel taraf ok + yüzde ile konuşur.
  trend: {
    increaseVsPrev: 'geçen döneme göre %{{value}} arttı',
    decreaseVsPrev: 'geçen döneme göre %{{value}} azaldı',
    flatVsPrev: 'geçen döneme göre değişmedi',
    prevPeriod: 'Önceki dönem',
    noPrevData: 'Kıyas için önceki dönemde veri yok',
  },

  // Ortak aksiyon/etiketler — birden fazla ekranda birebir ayni metin.
  actions: {
    cancel: 'İptal',
    confirm: 'Onayla',
    sendWarning: 'Uyarı Gönder',
    logout: 'Çıkış',
    howItWorks: 'Nasıl Çalışır?',
  },

  labels: {
    price: 'Fiyat:',
    amount: 'Miktar:',
    name: 'İsim:',
    company: 'Şirket:',
    transaction: 'İşlem:',
    // Metin BUYUK HARFLI cunku burada oyle yazildi — CSS text-transform ile DEGIL.
    // Turkce i/İ donusumu tarayici diline gore bozulur; karar ceviri dosyasinda verilir.
    buy: 'ALIŞ',
    sell: 'SATIŞ',
    summary: 'Özet',
    total: 'Toplam:',
    // Buronun gonderim penceresi (2026-09-26): musterinin hesabina gidecek tutar. Mobil ile ayni.
    toSend: 'Gönderilecek:',
    bankDetails: 'Banka bilgileri',
    dateFrom: 'Başlangıç',
    dateTo: 'Bitiş',
    unknownError: 'Bilinmeyen hata',
    unitRate: 'Birim kur',
  },

  // Talep / teklif ekranlari ve kartlari.
  // "Nasil calisir?" paneli (2026-09-07). Bu bolum uygulamada HIC yoktu; `actions.howItWorks`
  // anahtari katalogda duruyordu ama kaynak agacinda tek kullanimi bile yoktu.
  // SURE degerleri metne GOMULU DEGIL: sunucudan geliyor, cunku DOVIZHUB_TASK_PHASE_* ile
  // degistirilebiliyorlar ve yardim metni yalan soyleyemez.
  help: {
    customer: {
      create: {
        title: 'Talebinizi oluşturun',
        body: 'Almak ya da satmak istediğiniz tutarı ve bankanızı seçin. Seçtiğiniz bankada işlemin her iki para biriminde de hesabınız olmalı.',
      },
      collect: {
        title: 'Bürolar teklif verir',
        body: 'Talebiniz, sizinle aynı bankada ve aynı para birimlerinde hesabı olan bürolara iletilir. Teklifler geldikçe size gösterilir; seçimi teklif süresi bitince yaparsınız.',
      },
      choose: {
        title: 'En uygun teklifi seçin',
        body: 'Gelen teklifleri karşılaştırıp birini onaylarsınız. Onay geri alınamaz; onayladığınız anda diğer teklifler kapanır.',
      },
      pay: {
        title: 'Ödemeyi yapın',
        body: 'Seçtiğiniz büronun hesap bilgileri görünür hale gelir ve ödeme için bir süreniz olur.',
      },
      // Iki adimli buro onayi (2026-09-26): "Ödeme alındı" isi BITIRMEZ; buro dovizi gonderip
      // "İşlemi tamamla" dediginde tamamlanir. Metin mobil ile ayni.
      done: {
        title: 'Büro gönderir ve tamamlar',
        body: 'Büro ödemenizi aldığını onaylar, dövizinizi hesabınıza gönderir ve işlemi tamamlar. Tamamlanan işlem geçmişinize taşınır.',
      },
    },
    exchange: {
      see: {
        title: 'Talepler piyasada görünür',
        body: 'Yalnızca müşterinin seçtiği bankada, işlemin HER İKİ para biriminde de aktif hesabınız varsa talep size görünür.',
      },
      bid: {
        title: 'Teklifinizi verin',
        body: 'Teklif yalnızca toplama süresi içinde verilebilir ve aynı süre içinde güncellenebilir.',
      },
      wait: {
        title: 'Müşteri seçer',
        body: 'Müşteri tekliflerden birini onaylar. Kazanmadığınız talepler geçmişinize düşer.',
      },
      receive: {
        title: 'Ödemeyi bekleyin',
        body: 'Kazandığınız işlemde müşterinin ödeme yapması için bir süre vardır.',
      },
      confirm: {
        title: '"Ödeme alındı" deyin',
        body: 'Müşterinin ödemesi hesabınıza geçtiğinde onaylayın; işlem Ödenecekler’e taşınır. Onaylamazsanız işlem incelemeye alınır.',
      },
      // Ikinci adim (2026-09-26). Adim metinleri interpolasyon almiyor (HowItWorks yalniz
      // `rules` satirlarina sure geciriyor); gonderim suresi `rules.paymentWindow`da yazili.
      send: {
        title: 'Gönderin ve tamamlayın',
        body: 'Müşterinin hesabına gönderimi yapın ve "İşlemi tamamla" deyin. Gönderim süresi dolarsa işlem incelemeye alınır.',
      },
    },
    rules: {
      title: 'Süreler ve kurallar',
      offerWindow: 'Teklif toplama süresi: {{minutes}} dakika.',
      decideWindow: 'Karar süresi: teklif toplama bittikten sonra {{minutes}} dakika.',
      // Buronun gonderim suresi ayni sabit (sunucu: iki durum da 'payment' fazinda, 2026-09-26).
      paymentWindow:
        'Ödeme süresi: onaydan sonra {{minutes}} dakika. Büronun gönderim süresi de ödemeyi aldıktan sonra {{minutes}} dakika.',
      noOffers: 'Hiç teklif gelmezse talep otomatik kapanır ve "Teklif alınamadı" olarak işlem geçmişine düşer.',
      cancel: 'Talebi yalnızca siz ve yalnızca teklifler toplanırken iptal edebilirsiniz. Teklif toplama süresi bittikten sonra iptal yoktur.',
      // Uyari penceresi (2026-09-23): odeme suresi dolduktan sonra ya da tamamlanan islemde
      // itiraz suresi icinde. Sure sunucudan (disputeSeconds).
      // 2026-09-26: buronun gonderim suresi dolduysa da (payment_received) uyari acik.
      warning: 'Ödeme ya da büronun gönderim süresi dolduğu hâlde işlem tamamlanmadıysa uyarı gönderebilirsiniz. Tamamlanan bir işleme {{hours}} saat içinde itiraz edebilirsiniz.',
      grace: 'Süreler dolduktan {{minutes}} dakika sonra durum kendiliğinden ilerler ve ilgili taraflara bildirim gider.',
    },
  },
  task: {
    // Musteri org yoneticisi baskasinin talebini gorur; kimin oldugu yazilmali.
    owner: 'Talep sahibi',
    unknownOwner: 'Bilinmiyor',
    ownerOnlySelection: 'Kazanan teklifi yalnızca talebi oluşturan kişi seçebilir.',
    requestsTitle: 'Döviz Talepleri',
    // Büronun Piyasa ekranı (2026-10-02). "Döviz Talepleri" müşterinin Taleplerim başlığıyla
    // aynıydı; iki taraf aynı başlığı farklı ekranlar için görüyordu.
    marketTitle: 'Piyasa',
    offersTitle: 'Döviz Kur Teklifleri',
    myOffersTitle: 'Döviz Kur Tekliflerim',
    tabs: {
      all: 'Hepsi',
      openRequests: 'Açık Talepler',
      pending: 'Bekleyenler',
      toPay: 'Ödenecekler',
      // Buronun IKI ADIMLI onayi (2026-09-26; ilk surum 2026-09-07 tek adimdi).
      //   "Ödeme alındı"   : pending -> payment_received. Isi BITIRMEZ, Ödenecekler'e tasir.
      //   "İşlemi tamamla" : payment_received -> completed (doviz musteriye gonderildi).
      // Onaylanmayan adimda pencere + grace dolunca supurucu isi 'warning'e ceker.
      // Metinler mobil tr.ts `actions.*` ile ayni (web'de bu anahtarlar tarihsel olarak burada).
      paymentReceived: 'Ödeme alındı',
      paymentReceivedTitle: 'Ödemeyi onaylıyor musunuz?',
      paymentReceivedBody:
        'Müşterinin ödemesinin hesabınıza geçtiğini onaylıyorsunuz. İşlem Ödenecekler’e taşınır; gönderimi yaptıktan sonra "İşlemi tamamla" deyin. Bu adım geri alınamaz.',
      paymentReceivedDone: 'Ödeme alındı olarak işaretlendi. İşlem Ödenecekler’e taşındı.',
      completeTransaction: 'İşlemi tamamla',
      completeTransactionDone: 'İşlem tamamlandı.',
      past: 'Geçmiş',
      approved: 'Onaylanan',
      // Müşteri Taleplerim'in ikinci sekmesi (2026-10-02). Sekme anahtarı yine
      // 'approvedRequests'; "Onaylanan" büro ekranlarında kullanılmaya devam ediyor.
      inProgress: 'İşlemde',
      offers: 'Teklifler',
    },
    // Büro kartında karar sonucu (2026-10-02, M1).
    badges: {
      won: 'Kazandınız',
      lost: 'Başka büroya verildi',
      // Müşterinin talep detayında seçilen teklif (2026-10-02, M6).
      winner: 'Kazanan',
    },
    // Piyasa sonucu (2026-10-02): Gecmis karti rozeti + detaydaki sonuc karti basligi. Anahtar
    // adlari mobil tr.ts ile AYNI (sunucu degeri `won_by_org` -> `wonByOrg`); 'lost' icin
    // task.badges.lost kullanilir. Esleme tek yerde: features/tasks/market-outcome.ts.
    // 'closed' teklif vermemis buro icindir (K3): kimin secildigini ya da secim yapildigini
    // soylemez.
    marketOutcome: {
      won: 'Kazandınız',
      wonByOrg: 'Büronuz kazandı',
      closed: 'Kapandı',
      cancelled: 'İptal edildi',
      expired: 'Süresi doldu',
    },
    // Piyasa talep detayinda karar sonucu (2026-10-02). Baslik rozetle ayni
    // (task.marketOutcome); bunlar altindaki aciklama. 'expired': task.offerWindowClosed.
    marketResult: {
      won: 'Müşteri teklifinizi seçti. İşlemin sonraki adımları Tekliflerim’de.',
      wonByOrg: 'Müşteri işletmenizden bir iş arkadaşınızın teklifini seçti.',
      lost: 'Müşteri başka bir büronun teklifini seçti.',
      closed: 'Bu talep artık teklife açık değil.',
      cancelled: 'Müşteri bu talebi iptal etti.',
      // Teklif formu acikken karar geldi: form kapatilir, sonuc karti cikar.
      formClosed: 'Siz teklif girerken talep teklife kapandı; form kapatıldı.',
      goToOffers: 'Tekliflerim’e git',
    },
    // Kabuktaki kazanma bildirimi (2026-10-02, K4). Web'e push yok; Tekliflerim Bekleyenler
    // yoklanir ve yeni kazanilan is bir kez bildirilir. Kayip bildirilmez.
    winNotice: '#{{id}} size verildi',
    noRecords: 'Kayıt yok...',
    confirmTitle: 'İŞLEM ONAYI',
    areYouSure: 'Emin misiniz?',
    ibanCopied: 'IBAN kopyalandı!',
    selectBank: 'Banka Seçin',
    warning: 'Dikkat',
    paymentNotMade: 'Karşı ödeme yapılmadı ise lütfen onaylayınız.',
    accountMismatch: 'Lütfen seçili kur ve karşılığı için hesap ekleyiniz.',
    // Organizasyon üyesi IBAN ekleyemez (platform yönetiminde); ona "hesap ekleyin" demek
    // imkânsız bir işle göndermek olurdu.
    accountMissingPlatform:
      'Bu kur için işletmenize tanımlı bir IBAN yok. Talep oluşturabilmek için platform yönetiminden hesap tanımlanmasını isteyin.',
    myOffers: 'Tekliflerim',
    // --- Web istemcisine ozel satirlar. Mobilde karsiligi yok cunku bu
    // etkilesimler webe ait: adres cubugundan sayfalama, geri baglantilari,
    // ayri bir talep detayi rotasi.
    created: 'Talebiniz açıldı',
    offerSaved: 'Teklifiniz kaydedildi',
    offerAccepted: 'Teklif kabul edildi',
    acceptOfferDetail:
      'Bu teklif kabul edilecek ve işlem ödeme aşamasına geçecek. Aynı talep için başka bir teklif seçilemez.',
    myOfferPrice: 'Verdiğim fiyat:',
    // Bir buro bir teklif (2026-10-03): satirdaki teklif is arkadasinin (offer-ownership.ts).
    orgOfferPrice: 'Büronuzun teklifi:',
    offerLastUpdatedBy: 'Son güncelleyen:',
    unitRateHint:
      '1 birim için fiyat; 2 ondalık haneyle işlenir. Toplam, miktar ile çarpılarak hesaplanır.',
    offerWindowClosed: 'Bu talep için teklif toplama süresi doldu.',
    // 2026-09-23 (karar Q2) - 2026-10-02 arasi musteri teklif fazinda teklif gormuyordu. Kural
    // KALKTI (teklifler canli, secim yine karar fazinda); web'de bu anahtarin kullanimi yok,
    // mobil ile ayni yapi korunsun diye duruyor.
    offersHiddenUntilWindowCloses:
      'Teklifler, teklif toplama süresi bitince burada görünür. Seçim süresi o anda başlar.',
    selectionWindowClosed:
      'Teklif seçimi yalnızca teklif toplama süresi bittikten sonraki karar süresi içinde yapılabilir. Bu talep için seçim süresi doldu.',
    notFound: 'Talep bulunamadı',
    notFoundDetail: 'Talep kapanmış veya artık size gösterilmiyor olabilir.',
    backToMarket: 'Piyasaya dön',
    backToRequests: 'Taleplerime dön',
    sortDefault: 'Varsayılan sıralama',
    pagination: 'Sayfa gezintisi',
    previousPage: 'Önceki',
    nextPage: 'Sonraki',
    rangeLabel: '{{first}}–{{last}}. kayıt',
    // Taleplerim kartı ve talep detayı (2026-10-02, M2/M6). Teklifler teklif fazında da canlı
    // görünür; SEÇİM teklif süresi dolunca açılır (sunucu öncesinde 409 OFFER_WINDOW_OPEN).
    seeOffers: 'Teklifleri gör',
    requestDetail: 'Talep detayı',
    offersLiveEmpty: 'Henüz teklif gelmedi. Teklifler geldikçe burada görünür.',
    summary: {
      offerCount: '{{count}} teklif',
      best: 'en iyi {{price}}',
      noOffers: 'Henüz teklif yok',
      winner: 'Kazanan: {{name}}',
    },
    selection: {
      select: 'Seç',
      opensIn: 'Seçim {{time}} sonra açılır',
      open: 'Teklif süresi doldu — seçim yapabilirsiniz',
      // Sunucu saati istemciden birkaç saniye geride kaldığında 409 OFFER_WINDOW_OPEN.
      openingSoon: 'Seçim birkaç saniye içinde açılıyor',
    },
  },

  // Onaylanan teklifte musteriye odeme uyarisi ve Acik Talepler seridi (2026-09-26).
  // Anahtarlar mobil tr.ts ile ayni; web govdesi kalan sureyi de ({{time}}, mm:ss) yaziyor.
  paymentDue: {
    title: 'Ödemenizi yapın',
    body: 'Onayladığınız teklifin ödemesini {{time}} içinde büronun hesabına gönderin. Süre dolarsa işlem incelemeye alınır.',
    cta: 'Ödeme bilgileri',
    banner: '{{count}} onaylı işlemin ödemesi bekleniyor',
    bannerCta: 'Onaylanan’a git',
    // Web Taleplerim'de sekmenin adı 2026-10-02'den beri "İşlemde"; şerit oraya götürüyor.
    bannerCtaInProgress: 'İşlemde’ye git',
  },

  // Buronun ikinci adimi: musteriye gonderim ve "İşlemi tamamla" (2026-09-26). Mobil ile ayni.
  payoutSheet: {
    title: 'Gönderimi tamamlayın',
    description:
      'Müşterinin hesabına aşağıdaki tutarı gönderin. Gönderimi yaptıktan sonra işlemi tamamlayın.',
    confirm: 'Gönderimi yaptım, işlemi tamamla',
  },

  // Gonderim penceresindeki hesap/referans satirlari — mobil `approval` namespace'inden AYNI
  // adla alindi (dosya basindaki kural). Yalniz kullanilanlar tasindi.
  approval: {
    accountMissing: 'Hesap bilgisi alınamadı. Lütfen karşı tarafla iletişime geçin.',
    referenceLabel: 'Açıklama',
    copyReference: 'Kopyala',
    referenceCopied: 'Açıklama kopyalandı',
    // Web'e ozel: pano API'si guvenli baglam ister; yoksa kullanici kopyaladigini SANMAMALI.
    referenceCopyFailed: 'Açıklama kopyalanamadı',
  },

  // Duyurular: /yonetim'den gonderilen platform duyurularinin okuma tarafi.
  announcements: {
    title: 'Duyurular',
    open: 'Duyuruları aç',
    empty: 'Henüz duyuru yok',
    loadFailed: 'Duyurular getirilemedi.',
  },

  // Kur ekrani. TCMB bulteni sunucu vekili uzerinden geliyor (tarayici TCMB'ye
  // dogrudan gidemez, CORS yok).
  rates: {
    title: 'Güncel Kurlar',
    bulletinDate: 'TCMB bülteni: {{date}}',
    // `stale` YALNIZ TCMB'ye ulasilamadiginda dogru olur. Bultenin tarihinin
    // eski olmasi (hafta sonu/tatil -> son is gunu bulteni) NORMALDIR.
    stale: 'TCMB’ye şu an ulaşılamıyor. Son bilinen bülten gösteriliyor.',
    unavailable: 'Kur bilgisi alınamadı',
    unavailableDetail: 'Bülten şu an okunamıyor. Birkaç dakika sonra tekrar deneyin.',
    quotedPer: '{{unit}} birim üzerinden',
  },

  // Profil / kayit formu alan etiketleri. Alan tanimlari modul seviyesinde
  // yasadigi icin orada t() cagrilamaz; sabit yalniz ANAHTAR tutar (labelKey).
  fields: {
    userFullName: 'Ad Soyad',
    userEmail: 'E-posta',
    userCity: 'Şehir',
    userDistrict: 'İlçe',
    userPhone: 'Telefon',
    userIdentityId: 'TC Kimlik No',
    userBusinessName: 'İşletme Adı',
    userBusinessChamberName: 'Vergi Dairesi',
    userBusinessChamberNo: 'Vergi No',
    userPassword: 'Şifre',
    userPasswordRepeat: 'Şifre Tekrar',
    userBusinessAddress: 'Adres',
  },

  // Il/ilce secicisi (2026-10-02, M4).
  locations: {
    chooseCity: 'İl seçin',
    chooseDistrict: 'İlçe seçin',
    chooseCityFirst: 'Önce il seçin',
    notListed: '(listede yok)',
    pickFromList: 'Listeden seçin',
  },

  accounts: {
    pageName: 'Banka Hesapları',
    selectBank: 'Banka Seçin',
    selectCurrency: 'Kur Seçin',
    accountName: 'Hesap Adı',
    accountNumber: 'Hesap Numarası',
    give: 'Vazgeç',
    save: 'Kaydet',
    addAccount: 'Hesap ekle',
    editAccount: 'Hesabı düzenle',
    deleteTitle: 'Hesabı sil',
    deleteDescription:
      'Bu banka hesabı listenizden kaldırılacak. Talep ve tekliflerde artık seçilemez.',
    delete: 'Sil',
    addTry: 'TRY hesabı ekle',
    empty: 'Henüz banka hesabı eklemediniz.',
    emptyDescription: 'Talep açabilmek için en az bir banka hesabı gerekiyor.',
    // --- Web istemcisine özel (mobilde karşılığı olmayan) satırlar. IBAN
    // listede maskeli durduğu için "göster" / "kopyala" eylemleri yalnız
    // burada var; mobilde satır zaten tam IBAN'ı basıyor.
    showIban: 'IBAN’ı göster',
    hideIban: 'IBAN’ı gizle',
    copyIban: 'IBAN’ı kopyala',
    copyFailed: 'IBAN kopyalanamadı',
    ibanHint: 'IBAN listede maskeli görünür; kopyalayabilir veya kısaca gösterebilirsiniz.',
    accountNameHint: 'Bu hesabı tanımanız için kısa bir ad (örn. “Ticari hesap”).',
    bankRequired: 'Banka seçiniz',
    currencyRequired: 'Para birimi seçiniz',
    accountNameRequired: 'Hesap adı zorunludur',
    ibanRequired: 'IBAN zorunludur',
    ibanInvalid: 'Geçerli bir TR IBAN giriniz (TR ile başlayan 26 karakter).',
    saved: 'Hesap kaydedildi',
    saveFailed: 'Hesap kaydedilemedi',
    deleted: 'Hesap listenizden kaldırıldı',
    deleteFailed: 'Hesap kaldırılamadı',
    loadFailed: 'Hesaplar yüklenemedi',
    // ESKI METIN "yoneticinizden Hesap yonetimi yetkisi isteyin" diyordu; 2026-08-30'dan beri
    // YANLIS: o yetki artik atanamiyor (is_org_grantable=false) ve yonetici de ekleyemiyor.
    // Kullaniciyi imkansiz bir isle gonderen metin, calismayan bir dugmeden daha kotudur.
    readOnly:
      'IBAN’lar platform yönetimi tarafından tanımlanır. Yeni hesap eklenmesi veya mevcut bir hesabın güncellenmesi için platform yönetimine başvurun.',
  },

  profile: {
    pageName: 'PROFİL',
    back: 'Geri',
    deleteAccount: 'Hesabımı Sil',
    create: 'Teklif ver',
    update: 'Güncelle',
    firstLoginTitle: 'Hesabınızı tamamlayın',
    firstLoginSubtitle:
      'İşletmeniz sizin için bir hesap açtı. Devam etmeden önce yeni bir şifre belirleyin, birkaç bilgiyi tamamlayın ve aşağıdaki metinleri onaylayın.',
    complete: 'Tamamla',
    lastUpdate: 'Son Güncelleme',
    loginError: 'Giriş Hatası',
    emailAddress: 'E-posta adresi',
    myInfo: 'Bilgilerim',
    business: 'İşletme',
    businessInfo: 'İşletme bilgileri',
    team: 'Ekip ve yetkiler',
    reports: 'Raporlar',
    auditLog: 'İşlem geçmişi',
    appearance: 'Görünüm',
    themeSystem: 'Sistem',
    themeLight: 'Açık',
    themeDark: 'Koyu',
    app: 'Uygulama',
    version: 'Sürüm',
    deleteTitle: 'Hesabımı sil',
    deleteDescription:
      'Hesabınız ve kişisel bilgileriniz (kimlik ve iletişim bilgileri, banka hesaplarınız, bildirim kaydınız) silinecek. Bu işlem geri alınamaz.\n\nMevzuat gereği saklanması zorunlu işlem kayıtları, kimlik bilgilerinizden ayrıştırılarak saklanır.',
    deleteFailed: 'Hesap silinemedi',
    changePassword: 'Şifre değiştir',
    changePasswordHint:
      'Boş bırakırsanız şifreniz değişmez. Yeni şifre belirlerseniz tüm cihazlardaki oturumlarınız kapanır ve yeniden giriş yapmanız gerekir.',
    passwordChangedSignOut:
      'Şifreniz güncellendi. Güvenlik gereği tüm oturumlar kapatıldı; yeni şifrenizle giriş yapın.',
  },

  legal: {
    // NOT: hukuki METNIN KENDISI burada DEGIL — src/features/legal/legal-copy.ts
    // (mobil ile birebir ayni kaynak). Burada yalniz cevrilebilir arayuz cercevesi var.
    step: 'Adım {{current}} / {{total}}',
    kvkkTitle: 'Aydınlatma Metni',
    kvkkIntro: 'Devam etmeden önce lütfen aşağıdaki metni okuyunuz',
    usageTitle: 'Kullanım Koşulları',
    usageIntro: 'Devam etmek için lütfen aşağıdaki metni okuyunuz',
  },

  // Yetki kodu -> etiket. Yetki haritasi modul seviyesindedir; harita kod -> ANAHTAR
  // tutar, ceviri kullanim yerinde yapilir.
  permissions: {
    // Yedek metin: ekip ekrani once sunucu katalogundaki `descriptionTr`'yi gosterir.
    viewQuoteRequests: 'Piyasayı görüntüleme',
    createOffer: 'Teklif verme',
    editOffer: 'Teklif güncelleme / geri çekme',
    completeTask: 'İşlemi tamamlama',
    viewAccounts: 'Hesapları görüntüleme',
    manageAccounts: 'Hesap yönetimi',
    viewReport: 'Raporları görüntüleme',
    createReport: 'Rapor oluşturma',
    noPermissionOffer:
      'Teklif verme yetkiniz bulunmuyor. İşletme yöneticinizden talep edebilirsiniz.',
    noPermissionComplete:
      'İşlemi tamamlama yetkiniz bulunmuyor. İşletme yöneticinizden talep edebilirsiniz.',
  },

  // Denetim kaydi aksiyon kodlari -> etiket.
  auditActions: {
    memberInvited: 'Personel davet edildi',
    invitationCancelled: 'Davet iptal edildi',
    invitationAccepted: 'Davet kabul edildi',
    memberProvisioned: 'Hesap oluşturuldu',
    memberRemoved: 'Üye çıkarıldı',
    memberDeactivated: 'Üye pasifleştirildi',
    memberUpdated: 'Üye güncellendi',
    permissionGranted: 'Yetkiler güncellendi',
    permissionRevoked: 'Yetki geri alındı',
    organizationUpdated: 'İşletme bilgileri güncellendi',
    accountCreated: 'Hesap eklendi',
    accountUpdated: 'Hesap güncellendi',
    accountDeactivated: 'Hesap pasifleştirildi',
  },

  // Form dogrulama mesajlari. zod semalari t() alan birer FABRIKA olarak yazilir
  // (makeXSchema(t) + useMemo); modul seviyesinde t() cagirmak dil degisiminde
  // mesajlari bayat birakirdi.
  validation: {
    fullNameRequired: 'Ad Soyad zorunludur',
    cityRequired: 'Şehir zorunludur',
    districtRequired: 'İlçe zorunludur',
    phoneRequired: 'Telefon zorunludur',
    identityRequired: 'TC Kimlik No zorunludur',
    emailInvalid: 'Geçerli bir e-posta adresi giriniz',
    emailRequired: 'E-posta zorunludur',
    passwordLower: 'Şifre küçük harf içermelidir',
    passwordUpper: 'Şifre büyük harf içermelidir',
    passwordDigit: 'Şifre rakam içermelidir',
    passwordSpecial: 'Şifre özel karakter içermelidir',
    passwordMin: 'Şifre en az {{min}} karakter olmalıdır',
    passwordRequired: 'Şifre zorunludur',
    passwordsMustMatch: 'Şifreler eşleşmelidir',
    allFieldsRequired: 'Lütfen tüm alanları doldurunuz',
    amountInvalid: 'Değer uygun değil',
  },

  auth: {
    tagline: 'Döviz talebini aç, en iyi teklifi seç.',
    invalidCredentials: 'E-posta veya şifre hatalı',
    networkError: 'Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.',
    tooManyAttempts:
      'Çok fazla giriş denemesi yapıldı. Lütfen 15 dakika sonra tekrar deneyin.',
    passwordPolicy: 'Şifre kuralları',
    // Kendi kendine kayit YOK ve sifre sifirlama UCU YOK — hesabi yonetici aciyor.
    // Bu satir olmazsa sifresini unutan kullanici hicbir cikis yolu goremez.
    noSelfSignup:
      'Bu uygulamada kendi kendinize hesap açamazsınız. Hesabınız yoksa veya şifrenizi unuttuysanız işletme yöneticinize, işletmeniz yoksa platform yöneticisine başvurun.',
    password: 'Şifre',
    signIn: 'Giriş Yap',
    signingIn: 'Giriş yapılıyor…',
    loginErrorDetail: 'Giriş sırasında bir hata oluştu',
    completeFailed: 'Tamamlanamadı',
    genericProcessError: 'İşlem sırasında bir hata oluştu',
    profileUpdated: 'Profil bilgileriniz güncellendi.',
    updateError: 'Güncelleme Hatası',
    updateErrorDetail: 'Profil güncellenirken bir hata oluştu',
    deleteAccountError:
      'İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin veya destek ile iletişime geçin.',
    give: 'Vazgeç',
    backToLogin: 'Giriş Ekranına Dön',
    passwordRepeatRequired: 'Şifre tekrarı zorunludur',
    passwordsMismatch: 'Şifreler eşleşmiyor',
  },

  offerFlow: {
    createFailed: 'Teklif yaratılamadı. Lütfen hesap bilgilerinizi kontrol ediniz.',
    amountInvalidValue: 'Değer uygun değil',
    amountInvalid: 'Geçerli bir tutar girin',
    amountTooLarge: 'Tutar çok yüksek',
    // Teklif fiyati numeric(11,2): sunucu 3. ondaligi REDDEDIYOR (OFFER_PRICE_TOO_PRECISE).
    amountTooPrecise: 'Kur en fazla 2 ondalık basamak olabilir',
    // TCMB sapma uyarisi (ENGELLEMEZ). Esik: src/lib/offer-rate.ts OFFER_RATE_DEVIATION_WARN.
    rateDeviationWarn:
      'Bu kur, TCMB referans kurundan ({{reference}}) %{{percent}} farklı. Göndermeden önce kontrol edin.',
    create: 'Teklif ver',
    update: 'Güncelle',
    updateOrgOffer: 'Büronun teklifini güncelle',
    realized: 'Gerçekleşen',
    rejected: 'Reddedilen',
    warned: 'Uyarı Alınan',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    totalVolume: 'Toplam hacim',
    sendReport: 'Raporu e-postala',
    refresh: 'Yenile',
    select: 'Seç',
    noData: 'Bu aralıkta işlem yok.',
  },

  members: {
    removeTitle: 'Üyeyi çıkar',
    removed: 'Üye çıkarıldı.',
    changeRole: 'Rol değiştir',
    change: 'Değiştir',
    roleUpdated: 'Rol güncellendi.',
    allPermissions: 'Tüm yetkilere sahip',
    makeAdmin: 'Yönetici yap',
    orgUpdated: 'İşletme bilgileri güncellendi.',
    createAccount: 'Hesabı oluştur',
    permissionsHint:
      'Değişiklik hemen geçerli olur; personelin uygulaması yeni yetkilerle güncellenir.',
    unknownUser: 'Bilinmeyen kullanıcı',
    types: {
      admin: 'Yönetici',
      staff: 'Personel',
    },
    groups: {
      operation: 'Operasyon',
      finance: 'Finans',
      report: 'Raporlama',
      management: 'Yönetim',
    },
    makeStaff: 'Personel yap',
    passive: 'Pasif',
    team: 'Ekip',
    permissionCount: 'yetki tanımlı',
    staffMember: 'Personel',
    removeDescription:
      'Bu kişi organizasyondan çıkarılacak. Oturumu kapanır ve yetkileri kalkar.',
    done: 'Tamam',
    you: 'Siz',
  },

  // Organizasyon (isletme) yonetimi ekranlari.
  org: {
    onlyAdmins: 'Bu bölüm yalnızca yöneticilere açıktır.',
    profile: {
      pageName: 'İŞLETMEM',
      name: 'İşletme adı',
      email: 'E-posta',
      phone: 'Telefon',
      address: 'Adres',
      city: 'Şehir',
      district: 'İlçe',
      chamber: 'Ticaret odası',
      chamberNo: 'Vergi / oda numarası',
      saved: 'Kaydedildi',
      saveFailed: 'Kaydedilemedi',
      manageTeam: 'Ekibi yönet',
      save: 'Kaydet',
      saving: 'Kaydediliyor…',
      activeMembers: 'aktif üye',
      notMember: 'Bir işletmeye bağlı değilsiniz.',
      notMemberDetail:
        'Size bir davet kodu verildiyse işletme yöneticinizden hesabınızın tanımlanmasını isteyin.',
      staffReadOnly: 'İşletme bilgilerini yalnızca yöneticiler düzenleyebilir.',
    },
    members: {
      pageName: 'ÜYELER',
      empty: 'Henüz üye yok.',
      permissions: 'Yetkiler',
      remove: 'Çıkar',
      add: '+ Ekip üyesi ekle',
      actionFailed: 'İşlem başarısız',
    },
    permissions: {
      pageName: 'YETKİLER',
      saveFailed: 'Kaydedilemedi',
      catalogueFailed: 'Yetki listesi alınamadı.',
      saved: 'Yetkiler kaydedildi',
      hint: 'İşaretlediğiniz yetkiler bu personele verilir. Yönetici yetkileri (üye ve yetki yönetimi, denetim kaydı) personele devredilemez.',
      unsaved:
        'Kaydedilmemiş değişiklikleriniz var. Kaydettiğinizde işaretli olmayan tüm yetkiler geri alınır.',
      discard: 'Değişiklikleri geri al',
    },
    auditLog: {
      pageName: 'İŞLEM GEÇMİŞİ',
      empty: 'Henüz kayıt yok.',
      permissionsGranted: 'yetki tanımlandı',
      filterAction: 'İşlem türü',
      filterAll: 'Tüm işlemler',
      loadMore: 'Daha fazla göster',
    },
    invite: {
      pageName: 'EKİP ÜYESİ EKLE',
      fullName: 'Ad Soyad',
      fullNamePlaceholder: 'Personelin adı',
      email: 'E-posta',
      emailPlaceholder: 'ornek@firma.com',
      role: 'Rol',
      roleAdmin: 'Yönetici',
      roleStaff: 'Personel',
      roleAdminHint:
        'Yönetici tüm yetkilere sahiptir; ekibi ve işletme bilgilerini yönetebilir. Ayrıca yetki seçilmez.',
      roleStaffHint: 'Personel yalnızca aşağıda seçtiğiniz yetkilere sahip olur.',
      initialPermissions: 'Başlangıç yetkileri',
      initialPermissionsHint:
        'Hesap açıldığında bu yetkilerle başlar. Sonradan değiştirebilirsiniz.',
      invalidEmail: 'Geçersiz e-posta',
      invalidEmailDetail: 'Lütfen geçerli bir e-posta adresi giriniz.',
      fullNameRequired: 'Ad soyad gerekli',
      fullNameRequiredDetail: 'Lütfen personelin adını giriniz.',
      createFailed: 'Eklenemedi',
      shareFailed: 'Paylaşılamadı',
      created: 'Hesap oluşturuldu',
      createdNoEmail: 'Hesap oluşturuldu — e-posta gönderilemedi',
      sharePassword: 'Şifreyi paylaş',
      backToMembers: 'Üyelere dön',
      sending: 'Ekleniyor…',
      passwordEmailed: 'Geçici şifre e-posta ile gönderildi.',
      tempPassword: 'Geçici şifre',
      shareMessage: 'DovizHub — ekip hesabınız oluşturuldu',
    },
    reports: {
      range30: 'Son 30 gün',
      range90: 'Son 90 gün',
      rangeAll: 'Tümü',
      summary: 'Özet',
      offersGiven: 'Verilen teklif',
      offersWon: 'Kazanılan teklif',
      wonVolume: 'Kazanılan hacim',
      winRate: 'Kazanma oranı',
      byCurrency: 'Döviz cinsine göre',
      noOffers: 'Bu aralıkta teklif yok.',
      taskStatuses: 'İşlem durumları',
      noTasks: 'Bu aralıkta işlem yok.',
      memberPerformance: 'Personel performansı',
      memberInactive: '(üyeliği pasif)',
      noMemberActivity: 'Bu aralıkta personel hareketi yok.',
      pageName: 'RAPORLAR',
      won: 'kazanıldı',
      taskCount: 'işlem',
      wonVolumeLabel: 'Kazanılan hacim',
    },
    // Sunucu bu uclarda Turkce mesaj DEGIL sabit bir KOD doner
    // ('LAST_ADMIN_PROTECTED'). Kodu oldugu gibi basmak kullaniciya hicbir sey
    // anlatmaz; esleme src/features/organization/labels.ts icinde.
    errors: {
      nameRequired: 'İşletme adı zorunludur',
      lastAdminProtected:
        'İşletmede başka yönetici kalmıyor. Önce ikinci bir yönetici tanımlayın.',
      cannotModifyOwnMembership:
        'Kendi üyeliğinizi değiştiremezsiniz. Bunun için başka bir yöneticiye başvurun.',
      memberNotFound: 'Üye bulunamadı. Liste güncel olmayabilir; sayfayı yenileyin.',
      adminImplicitPermissions:
        'Yönetici zaten tüm yetkilere sahiptir; ayrıca yetki tanımlanamaz.',
      permissionNotGrantable: 'Seçilen yetkilerden biri personele devredilemez.',
      emailAlreadyRegistered: 'Bu e-posta adresiyle bir hesap zaten var.',
      invalidMemberType: 'Geçersiz rol.',
      organizationNotFound: 'İşletme kaydı bulunamadı.',
    },
  },

  // ======================= BURO PANELI (/buro/panel) =========================
  // Bu ekrandaki tutarlar GERCEK HACIM: sunucu `taskAmount * offerPrice`
  // carpimini kendisi yapiyor (db.js calculateVolume). Rapor ekranindakiler
  // OYLE DEGIL — bkz. `report` namespace'i ve src/lib/report-volume.ts.
  dashboard: {
    title: 'Panel',
    // Musteri paneli (/musteri/panel). Iki kapsam ayni ekranda: "benim" ve "organizasyon".
    // Metinler bu ayrimi ACIKCA soylemeli, yoksa yonetici org rakamini kendi sanir.
    customer: {
      title: 'Panel',
      subtitleAdmin:
        'Kendi taleplerinizin özeti ve işletmenizin geneli. İşletme bölümleri yalnızca yöneticilere görünür.',
      subtitleStaff: 'Kendi taleplerinizin özeti.',
      mine: 'Benim özetim',
      org: 'İşletme geneli',
      memberActivity: 'Üye aktivitesi',
      memberActivityHint:
        'İşletmenizdeki kişilerin talep ve işlem hacmi. Bu bölüm yalnızca yöneticilere görünür.',
      turnover: 'İşlem hacmi',
      taskCount: 'Talep',
      matchedCount: 'Eşleşen',
      countPair: '{{total}} talep · {{matched}} eşleşen',
      status: 'Durum',
      type: 'Tür',
      member: 'Üye',
      inactiveMember: 'Ayrılmış',
      unnamedMember: 'İsimsiz üye',
      emptyMine: 'Bu dönemde talebiniz yok.',
      emptyOrg: 'Bu dönemde işletmenizde talep yok.',
      emptyMembers: 'Bu dönemde üye aktivitesi yok.',
      loadFailed: 'Veriler getirilemedi.',
    },
    ownFiguresNote:
      'Bu sayfadaki tutarlar sizin kendi tekliflerinizin cirosudur; işletmenin tamamı değildir. İşletme geneli için Raporlar sayfasına bakın.',
    refresh: 'Yenile',
    sendReport: 'Raporu e-postala',
    dateFrom: 'Başlangıç',
    dateTo: 'Bitiş',
    rangeSummary: '{{from}} – {{to}} arasındaki işlemler',
    // Sunucu alici adresini cagiranin KENDI kaydindan cozuyor, istekten degil.
    // Kullanici baska bir adres bekliyorsa bunu onceden bilmeli.
    reportRecipientNote:
      'Rapor dosyası (xlsx) yalnızca kendi e-posta adresinize gönderilir: {{email}}. Başka bir adres seçilemez.',
    reportRecipientUnknown: 'kayıtlı adresiniz',
    reportQueued: 'Rapor hazırlanıyor; e-posta adresinize gönderilecek.',
    reportFailed: 'Rapor gönderilemedi. Lütfen tekrar deneyin.',
    noPermission: 'Bu sayfayı görme yetkiniz yok',
    noPermissionDetail: 'Panel için rapor görüntüleme yetkisi gerekir. İşletme yöneticinize başvurun.',
    loadFailed: 'Panel yüklenemedi',
    loadFailedDetail:
      'Sunucudan gelen yanıt okunamadı. Bu bir bağlantı sorunu olabilir; tekrar deneyin.',
    totalVolume: 'Toplam hacim',
    statusAccepted: 'Gerçekleşen',
    statusRejected: 'Kaybedilen',
    statusWarning: 'Uyarı alan',
    currencyCount: '{{n}} para birimi',
    noData: 'Bu aralıkta işlem yok',
    noDataDetail: 'Seçtiğiniz tarih aralığında kayıtlı teklifiniz bulunmuyor. Aralığı genişletmeyi deneyin.',
    breakdownCaption: '{{status}} — para birimine göre hacim',
    currencyColumn: 'Para birimi',
    volumeColumn: 'Hacim',
    // Mobil Özet ekranıyla parite (2026-08-30): hızlı aralık, dönem kıyası,
    // gerçekleşen payı ve tek kartta para birimi kırılımı.
    rangeQuick: 'Hızlı aralık',
    prevPeriodValue: 'Önceki dönem: {{value}}',
    realizedShare: 'Gerçekleşen payı',
    // Pay TEK birimde hesaplanir (2026-09-23): TRY ve USD hacimleri toplanmaz.
    realizedShareIn: 'Gerçekleşen payı ({{currency}})',
    currencySeparateNote:
      'Farklı para birimleri toplanmaz: TRY ve USD karşılıklı işlemler ayrı gösterilir (EUR/USD işlemleri USD’dir).',
    shareBarLabel: 'Durumların toplam hacimdeki payı',
    byCurrencyTitle: 'Para birimine göre dağılım',
    byCurrencyHint:
      'Her çubuk o işlem türünün hacmini karşı para biriminde (EUR/USD için USD, diğerleri için TRY) ve durum kırılımını gösterir.',
    seeReports: 'Rapor dökümü',
  },

  // ===================== ISLETME RAPORLARI (/buro/raporlar) ==================
  // DIKKAT: bu ekrandaki para rakamlari HACIM DEGIL, BIRIM KURLARIN TOPLAMI.
  // Sunucu SQL'i `sum(offer_price)` yaziyor; miktarla carpim YOK. Etiketler
  // bilincli olarak "hacim" demiyor (mobil ekran diyor ve yanlis).
  // Gerekce: src/lib/report-volume.ts.
  report: {
    title: 'Raporlar',
    scopeNote:
      'İşletmenin tamamını kapsar. Tutarlar birim kurların toplamıdır (ciro değildir); gerçek hacim için Panel sayfasına bakın.',
    refresh: 'Yenile',
    rangeLabel: 'Rapor aralığı',
    range30: 'Son 30 gün',
    range90: 'Son 90 gün',
    range1y: 'Son 1 yıl',
    rangeYtd: 'Yılbaşından beri',
    rangeAll: 'Tüm zamanlar',
    noPermission: 'Bu sayfayı görme yetkiniz yok',
    noPermissionDetail: 'Raporlar için rapor görüntüleme yetkisi gerekir. İşletme yöneticinize başvurun.',
    loadFailed: 'Raporlar yüklenemedi',
    loadFailedDetail:
      'Sunucudan gelen yanıt okunamadı. Bu bir bağlantı sorunu olabilir; tekrar deneyin.',
    offersGiven: 'Verilen teklif',
    offersWon: 'Kazanılan teklif',
    winRate: 'Kazanma oranı',
    wonRateSum: 'Kazanılan kur toplamı',
    rateSumHint: 'Birim kurların toplamı — ciro değildir.',
    byCurrency: 'Para birimine göre kazanılan teklifler',
    currencyColumn: 'Para birimi',
    noOffers: 'Bu aralıkta teklif yok',
    noOffersDetail: 'Seçtiğiniz dönemde işletmeniz adına verilmiş teklif bulunmuyor.',
    taskStatuses: 'İşlem durumlarına göre dağılım',
    statusColumn: 'Durum',
    taskCountColumn: 'İşlem sayısı',
    statusRateSum: 'Kur toplamı: {{value}} TRY',
    noTasks: 'Bu aralıkta işlem yok',
    noTasksDetail: 'Seçtiğiniz dönemde kapanmış bir işlem bulunmuyor.',
    wonOfCount: '{{total}} teklifin {{won}} tanesi kazanıldı',
    statusCompleted: 'Tamamlandı',
    statusPending: 'Beklemede',
    statusPaymentReceived: 'Ödeme alındı',
    statusWarning: 'Uyarı alan',
    statusCancelled: 'İptal edildi',
    statusPassive: 'Kapandı',
    statusNew: 'Açık',
    statusExpired: 'Süre doldu',
    statusNoOffers: 'Teklif alınamadı',
    statusResolved: 'Çözüldü',
    statusRefunded: 'İade edildi',
    memberPerformance: 'Personel performansı',
    // Sunucu bu ucu yoneticiye kilitliyor (ADMIN_REQUIRED). Gerekce yalniz
    // teknik degil: calisanlarin birbirinin verimini gormesi calisan izleme.
    memberAdminOnly: 'Bu bölüm yalnızca işletme yöneticilerine görünür.',
    // Ortalama karar süresi (talep açılışı → teklifin kabulü).
    decisionTime: 'Karar süresi',
    decisionTimeNote:
      'Talebin açılmasından teklifinizin kabul edilmesine geçen ortalama süre. Yalnızca kazandığınız işlemler sayılır.',
    decisionAverage: 'Ortalama',
    decisionCount: 'İşlem sayısı',
    noDecisionData: 'Bu dönemde ölçülebilen işlem yok.',
    decisionLoadFailed: 'Karar süresi getirilemedi.',
    // Süre birimleri: bu bir SÜRE, "3 saat önce" gibi geçmişe işaret eden bir ifade değil.
    durationSeconds: '{{value}} sn',
    durationMinutes: '{{value}} dk',
    durationHours: '{{value}} saat',
    durationDays: '{{value}} gün',
    // Ödeme uyarısı alan işlemler. Liste SAYFALANIR; "son 50 kayıt" ibaresi kalkti çünkü
    // sunucudaki sabit LIMIT 50 kaldırıldı ve artık tüm dönem gezilebiliyor.
    warnedTasks: 'Uyarı alan işlemler',
    warnedTasksNote: 'Kazandığınız işlemlerden ödeme uyarısı alanlar.',
    noWarnedTasks: 'Bu dönemde uyarı alan işlem yok.',
    warnedLoadFailed: 'Uyarı alan işlemler getirilemedi.',
    memberAdmin: 'Yönetici',
    memberStaff: 'Personel',
    memberInactive: 'Üyeliği kapalı',
    memberLoadFailed: 'Personel performansı yüklenemedi.',
    noMemberActivity: 'Bu aralıkta personel etkinliği yok.',
    unnamedMember: 'İsimsiz kullanıcı',
  },
  // ==========================================================================
  // PLATFORM YONETIMI (`super_admin` bolgesi — src/features/admin).
  //
  // Bu bolge BASKA INSANLARIN kisisel verisini gosteren tek yer. Metinler bunu
  // ustlenir: neyin maskeli oldugunu, bir islemin KIMI etkiledigini ve geri
  // alinip alinamayacagini acikca yazarlar.
  //
  // Sunucu bu uclarda Turkce mesaj DEGIL sabit bir KOD doner
  // ('CANNOT_MODIFY_SELF'); esleme src/features/admin/labels.ts icinde.
  // ==========================================================================
  admin: {
    loadMore: 'Daha fazla göster',
    revealContact: 'İletişim bilgilerini göster',
    yes: 'Evet',
    no: 'Hayır',

    filters: {
      all: 'Hepsi',
    },

    status: {
      active: 'Etkin',
      inactive: 'Pasif',
    },

    userTypes: {
      customer: 'Müşteri',
      exchange: 'Döviz bürosu',
    },

    roles: {
      superAdmin: 'Platform yöneticisi',
      user: 'Standart kullanıcı',
    },

    // Platform seviyesindeki denetim kaydi eylemleri (organizationId: null).
    // Buro seviyesindekiler icin var olan `auditActions.*` yeniden kullaniliyor.
    auditActions: {
      userActivated: 'Kullanıcı etkinleştirildi',
      userDeactivated: 'Kullanıcı pasifleştirildi',
      roleChanged: 'Platform rolü değiştirildi',
      passwordReset: 'Şifre sıfırlandı',
      orgActivated: 'İşletme etkinleştirildi',
      orgDeactivated: 'İşletme pasifleştirildi',
      orgCreated: 'İşletme oluşturuldu',
      memberProvisioned: 'Üye hesabı oluşturuldu',
      accountCreated: 'Banka hesabı tanımlandı',
      accountUpdated: 'Banka hesabı güncellendi',
    },

    audit: {
      platformScope: 'Platform',
      organizationScope: 'İşletme',
      scopedToOrganization: 'Tek işletmeye filtrelendi',
      scopedToActor: 'Tek kullanıcıya filtrelendi',
    },

    users: {
      title: 'Kullanıcılar',
      loadedCount: '{{n}} kayıt yüklendi',
      searchLabel: 'Ara',
      searchHint: 'Ad veya e-posta. Arama metni adres çubuğuna yazılmaz.',
      typeLabel: 'Taraf',
      statusLabel: 'Durum',
      sortNewest: 'En yeni',
      sortName: 'Ada göre',
      sortEmail: 'E-postaya göre',
      unnamed: 'Adı girilmemiş',
      noOrganization: 'İşletme üyeliği yok',
      joined: 'Kayıt: {{date}}',
      openDetail: 'Detay',
      filteredByOrganization: 'Tek işletmenin üyeleri gösteriliyor',
      phone: 'Telefon',
      city: 'Şehir',
      district: 'İlçe',
      createdAt: 'Kayıt tarihi',
      accountCount: 'Etkin / toplam banka hesabı',
      minimalProjectionNote:
        'Bu ekran kimlik numarası veya şifre bilgisi göstermez; sunucu bu alanları hiç göndermiyor.',
      contactSection: 'İletişim',
      membershipSection: 'İşletme üyeliği',
      memberType: 'İşletme içi rol',
      membershipStatus: 'Üyelik durumu',
      joinedAt: 'Katılım',
      openOrganization: 'İşletmeyi aç',
      consentSection: 'Onaylar',
      kvkk: 'KVKK aydınlatma metni',
      usageAgreement: 'Kullanım sözleşmesi',
      consentAccepted: 'Onaylandı · {{date}}',
      consentPending: 'Onay bekliyor',
      legalDocVersion: 'Belge sürümü',
      mustChangePassword: 'Şifre değiştirmesi gerekiyor',
      actionsSection: 'İşlemler',
      actionsNotice:
        'Aşağıdaki işlemler kullanıcının açık tüm oturumlarını sonlandırır ve işlem geçmişine yazılır.',
      selfActionsBlocked:
        'Kendi hesabınız üzerinde işlem yapamazsınız. Sunucu da bu isteği reddeder; gerekiyorsa başka bir platform yöneticisine başvurun.',
      viewAudit: 'Bu kullanıcının işlemleri',
      notFoundTitle: 'Kullanıcı açılamadı',

      deactivateAction: 'Pasifleştir',
      deactivateTitle: 'Kullanıcı pasifleştirilsin mi?',
      deactivateDescription:
        '{{name}} artık giriş yapamayacak ve açık tüm oturumları hemen sonlandırılacak. İşlem geri alınabilir.',
      activateAction: 'Etkinleştir',
      activateTitle: 'Kullanıcı etkinleştirilsin mi?',
      activateDescription: '{{name}} yeniden giriş yapabilecek.',
      promoteAction: 'Platform yöneticisi yap',
      promoteTitle: 'Platform yöneticisi yapılsın mı?',
      promoteDescription:
        '{{name}} bu ekranların tamamına — tüm kullanıcılar, tüm işletmeler ve duyurular — erişecek.',
      demoteAction: 'Yöneticiliği kaldır',
      demoteTitle: 'Yöneticilik kaldırılsın mı?',
      demoteDescription:
        '{{name}} platform yönetimi ekranlarına erişemeyecek. Sistemdeki son etkin platform yöneticisi ise sunucu bu isteği reddeder.',
      passwordResetAction: 'Şifre sıfırla',
      passwordResetTitle: 'Şifre sıfırlansın mı?',
      passwordResetDescription:
        '{{name}} için yeni bir geçici şifre üretilecek ve e-posta ile gönderilecek. Mevcut şifre anında geçersiz olur; işlem geri alınamaz.',
      passwordResetMailed: 'Geçici şifre e-posta ile gönderildi.',
      passwordResetNotMailed: 'E-posta gönderilemedi. Geçici şifre aşağıda — bir daha gösterilmeyecek.',
      tempPasswordTitle: 'Geçici şifre',
      tempPasswordNotice:
        'Bu değer yalnızca bir kez gösterilir; sunucu bir daha vermez. Kullanıcıya güvenli bir kanaldan iletin. İlk girişte kendisinden yeni bir şifre belirlemesi istenecek.',
      activated: 'Kullanıcı etkinleştirildi.',
      deactivated: 'Kullanıcı pasifleştirildi ve oturumları sonlandırıldı.',
      roleUpdated: 'Platform rolü güncellendi.',
    },

    // IBAN'lar platform yönetiminde: işletme tarafı salt okunur, tanımlama burada.
    accounts: {
      sectionTitle: 'Banka hesapları',
      sectionHint:
        'IBAN’lar yalnızca platform yönetimi tarafından tanımlanır. İşletme kendi ekranında bu hesapları yalnızca görüntüler.',
      empty: 'Tanımlı IBAN yok',
      emptyHint:
        'IBAN tanımlanmadan bu işletmenin kullanıcıları talep oluşturamaz; talep açarken hesap seçimi zorunludur.',
      loadFailed: 'Hesaplar getirilemedi.',
      inactive: 'Pasif',
      deactivate: 'Pasifleştir',
    },
    organizations: {
      title: 'İşletmeler',
      // İşletme + kurucu yönetici oluşturma (2026-08-30): self-servis kayıt kapatıldığı için
      // organizasyon yaratmanın TEK yolu bu akış.
      createTitle: 'Yeni işletme oluştur',
      createAction: 'Yeni işletme',
      created: 'İşletme oluşturuldu.',
      typeLabel: 'İşletme tipi',
      typeCustomer: 'Müşteri',
      typeExchange: 'Döviz bürosu',
      nameLabel: 'İşletme adı',
      chamberLabel: 'Bağlı olduğu oda',
      numberLabel: 'Sicil / oda numarası',
      founderSection: 'Kurucu yönetici',
      founderHint:
        'Bu kişi işletmenin ilk yöneticisi olur ve kendi personelini kendisi ekleyebilir. Giriş bilgileri e-posta ile gönderilir.',
      nextAddIban:
        'Sıradaki adım: işletmenin IBAN’ını tanımlayın. IBAN tanımlanmadan müşteri talep oluşturamaz.',
      addMemberTitle: 'İşletmeye üye ekle',
      addMemberAction: 'Üye ekle',
      addMemberHint: '“{{name}}” işletmesine yeni bir hesap açılacak.',
      memberCreated: 'Üye hesabı oluşturuldu.',
      loadedCount: '{{n}} kayıt yüklendi',
      searchLabel: 'Ara',
      createdAt: 'Kayıt: {{date}}',
      createdAtLabel: 'Kayıt tarihi',
      memberCount: '{{active}} / {{total}} üye',
      memberCountLabel: 'Etkin / toplam üye',
      openDetail: 'Detay',
      notFoundTitle: 'İşletme açılamadı',
      profileSection: 'İşletme bilgileri',
      membersSection: 'Üyeler',
      viewAsUsers: 'Üyeleri kullanıcı listesinde gör',
      viewAudit: 'Bu işletmenin işlemleri',
      actionsSection: 'İşlemler',
      statusNotice:
        'İşletmeyi pasifleştirmek, etkin tüm üyelerin açık oturumlarını aynı anda sonlandırır.',
      deactivateAction: 'İşletmeyi pasifleştir',
      deactivateTitle: 'İşletme pasifleştirilsin mi?',
      deactivateDescription:
        '{{name}} pasifleştirilecek ve etkin {{n}} üyenin açık oturumları hemen sonlandırılacak. İşlem geri alınabilir.',
      activateAction: 'İşletmeyi etkinleştir',
      activateTitle: 'İşletme etkinleştirilsin mi?',
      activateDescription: '{{name}} yeniden çalışabilir duruma gelecek.',
      activated: 'İşletme etkinleştirildi.',
      deactivated: 'İşletme pasifleştirildi; {{n}} üyenin oturumu sonlandırıldı.',
    },

    metrics: {
      title: 'Metrikler',
      subtitle: 'Platform genelindeki kullanıcı, işlem ve teklif sayıları.',
      jumpToBroadcast: 'Duyuru gönder',
      liveTotalsTitle: 'Anlık durum',
      liveBadge: 'Canlı',
      liveTotalsNotice:
        'Bu kutular ŞU ANIN sayımıdır; aşağıdaki tarih aralığı bunları etkilemez. Aralık yalnızca kayıt grafiğine uygulanır.',
      inactiveHint: '{{n}} pasif',
      organizations: 'İşletmeler',
      organizationsHint: 'Etkin / toplam',
      signupsTitle: 'Yeni kayıtlar',
      signupsNotice: 'Seçilen aralıkta açılan hesaplar.',
      periodLabel: 'Aralık',
      periodDay: 'Günlük',
      periodWeek: 'Haftalık',
      periodMonth: 'Aylık',
      noSeries: 'Bu aralıkta veri yok.',
      marketTitle: 'Pazaryeri özeti',
      taskTotal: 'Toplam talep',
      taskWon: 'Sonuçlanan talep',
      winRate: 'Sonuçlanma oranı {{rate}}',
      offerCount: 'Toplam teklif',
      offeredTaskCount: '{{n}} talebe teklif verildi',
      offeringOrganizations: 'Teklif veren işletme',
      offeringUsers: '{{n}} kullanıcı',
      volumeTitle: 'Para birimine göre hacim',
      currency: 'Para birimi',
      taskCount: 'Talep',
      wonTaskCount: 'Sonuçlanan',
      // Birimler satirda yaziyor (2026-09-23): miktar islem biriminde, karsilik karsi
      // birimde — EUR/USD'nin karsiligi USD, "TL" basligi yanlisti.
      totalAmount: 'Talep miktarı',
      wonCounterValue: 'Sonuçlanan karşılık',
      timeseriesTitle: 'Zaman serisi',
      metricLabel: 'Ölçü',
      metricTasks: 'Talepler',
      metricOffers: 'Teklifler',
      metricVolume: 'Hacim',
      chartSummary: 'toplam {{total}}, en yüksek {{peak}} ({{peakLabel}})',
      showTable: 'Veriyi tablo olarak göster',
      bucket: 'Dönem',
      value: 'Değer',
    },

    activity: {
      title: 'Son hareketler',
      empty: 'Henüz hareket yok.',
      eventTask: 'Yeni talep',
      eventOffer: 'Yeni teklif',
    },

    broadcast: {
      title: 'Duyuru gönder',
      warning:
        'Gönderilen bildirim seçtiğiniz kitledeki HERKESE ulaşır ve geri alınamaz. Göndermeden önce önizlemeyi okuyun.',
      audienceLabel: 'Kitle',
      audienceCustomer: 'Yalnızca müşteriler',
      audienceExchange: 'Yalnızca döviz büroları',
      audienceAll: 'Tüm kullanıcılar',
      titleLabel: 'Başlık',
      bodyLabel: 'Metin',
      previewLabel: 'Önizleme',
      previewEmptyTitle: 'Başlık yazın',
      previewEmptyBody: 'Bildirim metnini yazın',
      sendAction: 'Gönder',
      confirmTitle: 'Duyuru gönderilsin mi?',
      confirmDescription:
        '"{{title}}" başlıklı bildirim {{audience}} kitlesindeki herkese gönderilecek. İşlem geri alınamaz.',
      sent: 'Duyuru gönderildi.',
      resultTitle: 'Gönderim sonucu',
      // successCount TOPIC kipinde bir teslimat sayisi DEGIL; metin bu yuzden
      // sayi degil konu adi gosteriyor.
      topicDelivery:
        'Konuya gönderildi ({{topics}}). Bildirimi kaç cihazın aldığı bu kipte ölçülemez.',
      tokenDelivery: '{{tokens}} cihaz · {{success}} başarılı · {{failure}} başarısız',
      historyTitle: 'Gönderilen duyurular',
      historyEmpty: 'Henüz duyuru gönderilmedi.',
    },

    errors: {
      badShape:
        'Sunucunun yanıtı beklenen biçimde değil. Kayıt olmadığı anlamına gelmez; tekrar deneyin.',
      cannotModifySelf:
        'Kendi hesabınız üzerinde bu işlemi yapamazsınız. Başka bir platform yöneticisine başvurun.',
      lastSuperAdminProtected:
        'Sistemdeki son etkin platform yöneticisi bu şekilde kaldırılamaz. Önce ikinci bir platform yöneticisi tanımlayın.',
      userNotFound: 'Kullanıcı bulunamadı. Liste güncel olmayabilir; sayfayı yenileyin.',
      organizationNotFound: 'İşletme bulunamadı. Liste güncel olmayabilir; sayfayı yenileyin.',
      statusUpdateFailed: 'Durum güncellenemedi.',
      roleUpdateFailed: 'Rol güncellenemedi.',
      passwordResetFailed: 'Şifre sıfırlanamadı.',
      invalidRole: 'Geçersiz rol.',
      invalidStatus: 'Geçersiz durum değeri.',
      invalidFilter: 'Seçilen filtre sunucu tarafından tanınmadı.',
      invalidDateRange: 'Tarih aralığı geçersiz.',
      metricsFailed: 'Metrikler hesaplanamadı.',
      superAdminNotAssignable:
        'Platform yöneticiliği arayüzden verilemez; yalnızca veritabanı üzerinden tanımlanır.',
      organizationNameRequired: 'İşletme adı zorunludur.',
      invalidOrganizationType: 'Geçersiz işletme tipi.',
      invalidEmail: 'Geçerli bir e-posta adresi girin.',
      fullNameRequired: 'Ad soyad zorunludur.',
      businessRegistrationRequired: 'Döviz bürosu için oda ve sicil numarası zorunludur.',
      emailAlreadyRegistered: 'Bu e-posta adresi zaten kayıtlı.',
      invalidMemberType: 'Geçersiz üye tipi.',
      adminPermissionsImplicit: 'Yönetici zaten tüm yetkilere sahiptir; ayrıca yetki atanamaz.',
      permissionNotGrantable: 'Seçilen yetkilerden biri personele atanamaz.',
      accountNotFound: 'Banka hesabı bulunamadı.',
      accountIbanInvalid: 'IBAN geçersiz. TR ile başlayan 26 karakterlik IBAN giriniz.',
      accountListFailed: 'Banka hesapları getirilemedi.',
      accountUpdateNoOp: 'Hesap güncellenemedi; kayıt değişmedi.',
      invalidAudience: 'Geçersiz kitle.',
      titleRequired: 'Başlık zorunludur.',
      bodyRequired: 'Bildirim metni zorunludur.',
      titleTooLong: 'Başlık 100 karakteri aşamaz.',
      bodyTooLong: 'Bildirim metni 500 karakteri aşamaz.',
      invalidTargetUser: 'Hedef kullanıcı geçersiz.',
      broadcastFailed: 'Duyuru gönderilemedi.',
      forbidden: 'Bu işlem için platform yöneticisi olmanız gerekiyor.',
      taskNotInWarning:
        'Bu işlem artık uyarıda değil; başka bir yönetici sonuçlandırmış olabilir. Liste yenilendi.',
      invalidResolution: 'Geçersiz sonuç. Çözüldü ya da İade edildi seçin.',
      resolutionNoteTooLong: 'Not 1000 karakteri aşamaz.',
    },

    // Uyari cozum kuyrugu (/yonetim/uyarilar, 2026-09-23 karar Q3).
    warned: {
      title: 'Uyarı alan işlemler',
      subtitle:
        'Müşterinin "ödeme yapılmadı" uyarısı gönderdiği işlemler. İki tarafla görüşüp sonucu kaydedin; kayıt geri alınamaz ve iki tarafa bildirim gider.',
      loadedCount: '{{n}} kayıt yüklendi',
      empty: 'Uyarıda bekleyen işlem yok',
      sortOldest: 'En eski uyarı önce',
      sortNewest: 'En yeni uyarı önce',
      task: 'İşlem #{{id}}',
      warnedAt: 'Uyarı: {{date}}',
      decidedAt: 'Onay: {{date}}',
      amount: 'Miktar',
      price: 'Kur',
      total: 'Tutar',
      customer: 'Müşteri',
      exchange: 'Döviz bürosu',
      noOffer: 'Kazanan teklif bulunamadı',
      resolveAction: 'Sonuçlandır',
      resolveTitle: 'İşlem #{{id}} sonuçlandırılsın mı?',
      resolutionLabel: 'Sonuç',
      resolved: 'Çözüldü',
      refunded: 'İade edildi',
      resolvedHint: 'Döviz karşı tarafa ulaştı ya da anlaşmazlık giderildi.',
      refundedHint: 'Müşterinin ödemesi iade ettirildi.',
      noteLabel: 'Not (isteğe bağlı)',
      noteHint: 'Kim ile görüşüldü, ne kararlaştırıldı. En fazla 1000 karakter.',
      confirmAction: 'Kaydet',
      irreversible: 'Bu kayıt geri alınamaz; işlem uyarı kuyruğundan çıkar ve iki tarafa bildirim gider.',
      resolvedDone: 'İşlem sonuçlandırıldı: {{resolution}}.',
    },
  },

} as const;

export default tr;
